/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import GoogleCertificate from 'bundles/epic/data/defaults/GoogleCertificate.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  routeToFinancialAidApplicationV3: boolean;
  isFreemiumModelRolloutGAEnabled: boolean;
  coursePriceIncreaseTo72: 'control' | 'test';
  surfacePreviewLink: 'control' | 'variant1' | 'variant2' | 'variant3' | 'variant4';
  highIncomeCountryPricingTestVariant: 'control' | 'variant1';
  shortS12nFreeTrialOverrideEnabled: boolean;
  shortS12nFreeTrialOverrideDayCount: -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
};

const NAMESPACE = 'GoogleCertificate';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([GoogleCertificate as $TSFixMe]);

const GoogleCertificateEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default GoogleCertificateEpicClient;
